<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <h3 class="text-inherit">Create Group</h3>

        <p>
          Create a new group for people to share their REALITi content with the
          rest of iSimulate's simulation community.
        </p>

        <form>
          <div class="form-group">
            <label for="new-group-name">Name *</label>
            <input
              type="text"
              v-model="groupName"
              :class="{ 'form-control': true, 'is-invalid': !groupNameValid }"
              name="name"
              id="new-group-name"
            />
          </div>
          <div class="form-group">
            <label for="new-group-description">Description</label>
            <textarea
              name="description"
              class="form-control"
              v-model="groupDesc"
              id="new-group-description"
            ></textarea>
          </div>

          <div class="form-group">
            <label>Membership</label>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="membershipType"
                id="publicMembership"
                value="public"
                v-model="membershipType"
                checked
              />
              <label class="form-check-label" for="publicMembership">
                Public
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="membershipType"
                id="inviteMembership"
                value="inviteOnly"
                v-model="membershipType"
              />
              <label class="form-check-label" for="inviteMembership">
                Invite only
              </label>
            </div>
          </div>

          <div class="form-group">
            <label>Posts</label>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="postingType"
                id="allow-all-posts"
                value="allowAll"
                v-model="postingType"
                checked
              />
              <label class="form-check-label" for="allow-all-posts">
                Allow all posts
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="postingType"
                id="require-post-approval"
                value="requireModeration"
                v-model="postingType"
              />
              <label class="form-check-label" for="require-post-approval">
                Require approval
              </label>
            </div>
          </div>

          <button
            class="btn btn-primary mr-2 flex-grow d-lg-block"
            @click.prevent="submit()"
          >
            {{ buttonText }}
          </button>
        </form>
      </CommunityCard>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import forumGroupService from "../services/forumgroup.service";
import CommunityCard from "@/components/CommunityCard";

export default {
  name: "CreateForumGroup",
  components: {
    CommunityCard,
    UserMenu,
  },
  data: function () {
    return {
      groupName: "",
      groupDesc: "",
      groupNameValid: true,
      membershipType: "public",
      postingType: "allowAll",
      isSubmitting: false,
      buttonText: "Save",
    };
  },
  methods: {
    submit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      if (!this.validate()) {
        this.isSubmitting = false;
        return;
      }

      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.buttonText = "...";

      forumGroupService
        .createGroup(
          this.groupName,
          this.groupDesc,
          this.membershipType,
          this.postingType
        )
        .then((data) => {
          swalWithBootstrapButtons
            .fire("Created!", "Your group has been created.", "success")
            .then(() => {
              this.$router.push({
                name: "forum-group",
                params: { groupId: data.id },
              });
            });
        })
        .finally(() => {
          this.groupName = "";
          this.groupDesc = "";
          this.membershipType = "public";
          this.postingType = "allowAll";
          this.isSubmitting = false;
          this.buttonText = "Save";
        });
    },
    validate() {
      this.groupName = this.groupName.trim();
      this.groupNameValid = this.groupName.length > 0;
      return this.groupNameValid;
    },
  },
};
</script>

<style scoped></style>
